import { JournalOptionEnum } from '~modules/connectors/constants/journal.options';
import { ReverseChargeAggregateOptionEnum } from '~modules/connectors/constants/reverse-charge-aggregate.options';
import { AccountingEntriesFieldsConfiguration, DescriptionOption } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { getPaymentEntryDescriptionFieldOptions, getPaymentEntryLineDescriptionFieldOptions, defaultEntryDescriptionEmptyFieldOption, defaultEntryLineDescriptionStandardFieldOption, clientThirdPartyTemplatingOptions, clientThirdPartTemplatingNameFieldOption, supplierThirdPartyTemplatingOptions, supplierThirdPartTemplatingNameFieldOption, getPaymentGroupingDescriptionFieldOptions, defaultGroupingDescriptionEmptyFieldOption } from './default-transformation-fields';

const stripePaymentGroupingDescriptionOptions: DescriptionOption[] = getPaymentGroupingDescriptionFieldOptions();

const stripePaymentEntryDescriptionOptions: DescriptionOption[] = getPaymentEntryDescriptionFieldOptions({
    withThirdPart: true
});

const stripePaymentEntryLineDescriptionOptions: DescriptionOption[] = getPaymentEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

export const stripeTransformationFieldsConfiguration: AccountingEntriesFieldsConfiguration = {
    toolLabel: 'Stripe',

    paymentProcessorConfiguration: {
        journalOption: {
            visible: false,
            defaultValue: JournalOptionEnum.UNIQUE,
        },
        uniqueJournal: {
            code: {
                defaultValue: 'STR'
            },
            label: {
                defaultValue: 'Stripe'
            }
        },
        client: {
            useSuggestedAccounts: {
                visible: false,
                defaultValue: false
            },
            account: {
                defaultValue: '411'
            },
            label: {
                defaultValue: 'Clients'
            },
            isDynamic: {
                defaultValue: false
            },
            auxiliaryLabelStatic: {
                defaultValue: 'STRIPE'
            },
            auxiliaryAccountStatic: {
                defaultValue: 'STRIPE'
            },
            auxiliaryDynamic: {
                options: clientThirdPartyTemplatingOptions,
                defaultOption: clientThirdPartTemplatingNameFieldOption
            }
        },
        supplier: {
            visible: false,
            useSuggestedAccounts: {
                visible: false,
                defaultValue: false
            },
            account: {
                defaultValue: '401'
            },
            label: {
                defaultValue: 'Fournisseurs'
            },
            isDynamic: {
                defaultValue: false
            },
            auxiliaryLabelStatic: {
                defaultValue: 'STRIPE'
            },
            auxiliaryAccountStatic: {
                defaultValue: 'STRIPE'
            },
            auxiliaryDynamic: {
                options: supplierThirdPartyTemplatingOptions,
                defaultOption: supplierThirdPartTemplatingNameFieldOption
            }
        },
        useSuggestedProviderAccounts: {
            visible: false,
            defaultValue: false
        },
        methods: {
            unique: true,
            bankSupplierVisibleFor: [null],
            defaultMethod: {
                name: null,
                export: true,
                journalCode: null,
                internalTransfer: {
                    account: '581',
                    label: 'Virement interne STRIPE'
                },
                provider: {
                    account: '5171',
                    label: 'STRIPE'
                },
                bankSupplier: {
                    account: '401',
                    label: 'Fournisseurs',
                    auxiliaryAccount: 'STRIPE',
                    auxiliaryLabel: 'STRIPE'
                }
            }
        },
        providerFee: {
            account: {
                defaultValue: '62781'
            },
            label: {
                defaultValue: 'Autres frais et commissions sur prestations de services'
            }
        },
        deductibleVat20: {
            visible: false,
            account: {
                defaultValue: '44566'
            },
            label: {
                defaultValue: 'TVA sur autres biens et services'
            }
        },
        reverseCharge: {
            has: {
                defaultValue: false
            },
            aggregateOption: {
                defaultValue: ReverseChargeAggregateOptionEnum.EACH
            },
            collectedIntracomVat: {
                account: {
                    defaultValue: '4452'
                },
                label: {
                    defaultValue: 'TVA due intracommunautaire'
                }
            },
            deductibleIntracomVat: {
                account: {
                    defaultValue: '445662'
                },
                label: {
                    defaultValue: 'TVA intracommunautaire sur autres biens et services'
                }
            },
            vatRate: {
                defaultValue: 20.00
            }
        },
        useSuggestedCounterpartAccounts: {
            visible: false,
            defaultValue: false
        },
        undefinedCredit: {
            visible: false,
            account: {
                defaultValue: '471'
            },
            label: {
                defaultValue: 'Opérations à reclasser'
            }
        },
        undefinedDebit: {
            visible: false,
            account: {
                defaultValue: '471'
            },
            label: {
                defaultValue: 'Opérations à reclasser'
            }
        },
        groupingDescription: {
            visible: false,
            options: stripePaymentGroupingDescriptionOptions,
            defaultOption: defaultGroupingDescriptionEmptyFieldOption
        },
        entryDescription: {
            options: stripePaymentEntryDescriptionOptions,
            defaultOption: defaultEntryDescriptionEmptyFieldOption,
        },
        entryLineDescription: {
            options: stripePaymentEntryLineDescriptionOptions,
            defaultOption: defaultEntryLineDescriptionStandardFieldOption,
        }
    },

    analyticProcessorConfiguration: {
        isEnabled: {
            defaultValue: false
        },
        accountRules: {}
    }
}